<template>
  <div>
    <label
      v-if="!noLabel"
      :class="id == 'cvsStatus' ? 'acs-input-head' : 'teams-label-font'"
      >{{ label }}<span v-if="mandatory" class="asterik">*</span></label
    >
    <div class="select-div topDiv">
      <b-form-input
        :disabled="disabled"
        ref="landingdrop"
        :id="id"
        @click="checkAndOpen()"
        class="teams-inputField"
        :placeholder="placeholder"
        v-model.trim="inputData"
        @input="(openDropdown = true), handleInput($event)"
        :class="{
          error: showError,
        }"
      ></b-form-input>
      <!-- @click="openDropdown = !openDropdown" -->
      <div
        v-closable="{
          exclude: ['landingdrop'],
          handler: 'hideLandingDropdown',
        }"
        v-if="openDropdown && filteredOptions.length != 0"
        class="selectCustom-dropdown pointer"
      >
        <div
          class="selectCustom-dropdown-innerContent"
          v-for="(opt, index) in filteredOptions"
          :key="index"
          :id="opt.key"
          @click.stop="selectOption(opt)"
          :class="{
            'selectCustom-opt-selected': isSelected(opt),
            'selectCustom-opt-unselected': !isSelected(opt),
          }"
          :tabindex="index === 0 ? 0 : -1"
        >
          {{ opt.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputDropdown",
  props: {
    selectbindingClass: String,
    disableDropdown: Boolean,
    disabled: Boolean,
    noLabel: Boolean,
    mandatory: Boolean,
    dropdown: Boolean,
    showError: Boolean,
    label: String,
    placeholder: String,
    id: String,
    api: String,
    fieldType: String,
    values: Array,
    from: String,
    type: String,
    vmodel: {
      validator: function () {
        return true;
      },
    },
  },
  data() {
    return {
      openDropdown: false,
      selectedValue: "",
      dropDownOptions: [],
      selectedObject: {},
      inputData: "",
    };
  },
  computed: {
    placeholderText() {
      return Object.keys(this.selectedObject).length > 0;
    },
    filteredOptions() {
      const startsWithSelected = this.dropDownOptions.filter((option) =>
        option.label.toLowerCase().startsWith(this.inputData.toLowerCase())
      );

      // Filter options that contain the selected input
      const containsSelected = this.dropDownOptions.filter(
        (option) =>
          !option.label
            .toLowerCase()
            .startsWith(this.inputData.toLowerCase()) &&
          option.label.toLowerCase().includes(this.inputData.toLowerCase())
      );
      return [...startsWithSelected, ...containsSelected];
    },
  },
  watch: {
    values(val) {
      this.dropDownOptions = val;
    },
    vmodel() {
      this.resetValues();
    },
    disabled(val) {
      if (val) this.openDropdown = false;
    },
  },
  created() {
    if (this.dropdown) {
      this.dropDownOptions = this.values;
    } else {
      this.getDropdownOptions();
    }
    this.resetValues();
  },
  methods: {
    checkAndOpen() {
      if (!this.selectedValue) {
        this.openDropdown = !this.openDropdown;
      }
    },
    handleInput(value) {
      let matchedValue = this.dropDownOptions.find(
        (obj) => obj.label.toLowerCase() == value.toLowerCase()
      );
      if (matchedValue) {
        this.$emit("select-input-value", matchedValue.key, "predefined");
        this.inputData = matchedValue.label;
        this.selectedObject = matchedValue;
        this.selectedValue = matchedValue.key;
        this.openDropdown = false;
      } else {
        this.$emit("select-input-value", value, "custom");
        this.inputData = value;
        this.selectedObject = {};
        this.selectedValue = "";
      }
    },
    selectOption(value) {
      this.inputData = value.label;
      this.selectedObject = value;
      this.selectedValue = value.key;
      this.$emit("select-input-value", value.key, "predefined");
      this.openDropdown = false;
    },
    resetValues() {
      if (this.vmodel) {
        if (this.type == "predefined") {
          this.selectedValue = this.vmodel;
          let selObject = this.dropDownOptions.find((obj) => {
            return obj.key === this.selectedValue;
          });
          this.selectedObject = selObject;
          this.inputData = this.selectedObject?.label;
          this.$emit("select-input-value", this.selectedValue, this.type);
        } else {
          this.inputData = this.vmodel;
          this.$emit("select-input-value", this.vmodel, this.type);
        }
      }
    },
    async getDropdownOptions() {
      this.dropDownOptions = [];
    },
    hideLandingDropdown() {
      this.openDropdown = false;
    },
    isSelected(option) {
      return this.selectedObject && this.selectedObject.key === option.key;
    },
  },
};
</script>

<style scoped>
.topDiv > .error {
  border: 1px solid red !important;
}
</style>
